/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import getColumns from './columns';
import { actions } from '../../../store/reducers/ic';
import Table from '../../Table';
import { findOptions } from '../../../helpers/StringHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../../Loading';
import PageHeader from '../../Layout/PageHeader';

const Styles = Styled.div`
  .ant-page-header {
    padding: 8px 8px 8px var(--size);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .ant-page-header-heading {
			justify-content: flex-start;
    }
    .ant-page-header-heading-extra {
			display: flex;
			margin-left: var(--size);
		}
    .ant-btn {
      display: flex;
      span[role="img"] {
        font-size: 18px;
      }
    }
  }
  .ant-space {
    width: 100%;
    .ant-space-item {
      width: 100%;
    }
  }
  .ant-btn {
    display: flex;
    span[role="img"] {
      margin: auto;
    }
  }
  .ant-input-affix-wrapper-disabled  {
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    input {
      background-color: transparent;
      cursor: text;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .columns {
    span[role="img"] {
      margin-left: 8px
    }
  }
  .projectLink {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    text-decoration: underline;
  }
  .ant-drawer-body {
    padding: 0;
  }
`;

function PMEIC({
  ic: { data, loading },
  authentication: { user, selectedProject },
  icDataGet,
}) {
  const { t, i18n: { language } } = useTranslation();
  const columns = getColumns(t);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    showSizeChanger: true,
  });

  const [ic, setIc] = useState([]);
  const location = useLocation();
  const goTo = useNavigate();
  const params = new URLSearchParams(location.search);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    icDataGet({ module: 'pme', view: 'informationClients' });
  }, [selectedProject, user.language])

  useEffect(() => {
    if (data.data) {
      const { categoryOptions, subCategory, subjectOptions } = data.options || {};
      setIc(data.data.map(i => {
        i.category = findOptions(i.category, categoryOptions || []) || '';
        i.subCategory = findOptions(i.subCategory, subCategory || []) || '';
        i.subjects = i.subjects.map(s => {
          const opt = subjectOptions.find(o => o.value === s);
          return opt ? opt.label[language] : '';
        });
        i.type = t(i.type);
        return i;
      }))
    }
  }, [data.data]);

  const updateQuery = (filters, page) => {
    const qs = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&');
    goTo(qs !== '' ? `/app/pme/ic?${qs}` : `/app/pme/ic?page=${page}`);
  }

  return loading ? <Loading /> : (
    <Styles>
      <PageHeader title={t("Information Clients")} />
      <div className="column start" style={{ padding: '0 18px' }}>
        <Table
          style={{ marginTop: '12px' }}
          size="small"
          columns={columns}
          rowKey="datastakeId"
          data={ic}
          options={{
            category: data && data.options ? data.options.categoryOptions : [],
            subCategory: data && data.options ? data.options.subCategory : [],
          }}
          defaultFilters={columns
            .filter(col => col.search || col.primarySearch)
            .map(col => col.dataIndex)
            .reduce((values, key) => {
              if (params.has(key)) {
                values[key] = params.get(key);
              }
              return values;
            }, {}) || {}}
          onFilterChange={(filters) => {
            let page = params.get('page');
            if (isNaN(Number(page)) || page === 'null' || page === null) {
              page = 1;
            }
            filters = StorageManager.saveFilters('pme', 'ic', { ...filters, page });
          }}
          onChange={(page) => {
            if (isNaN(page.current)) {
              page.current = 1;
            }
            const filters = StorageManager.saveFilters('pme', 'ic', { page: page.current }, true);
            updateQuery(filters, page.current);
            setPagination({
              showSizeChanger: true,
              current: page.current,
              pageSize: page.pageSize
            });
          }}
          pagination={pagination}
        />
      </div>
    </Styles>
  )
};

const mstp = (state) => ({ authentication: state.authentication, ic: state.ic });

export default connect(mstp, actions)(PMEIC);
